import { useEffect, useState } from "react";
import { fetchPrismic } from "src/services/fetchPrismic.service";

import { IData, IPrismicPage } from "../PageCmsCustom/types";

export const usePrismicData = ({
  cmsId,
  cmsType,
}: IPrismicPage): IData | undefined => {
  const [data, setData] = useState<IData>();

  useEffect(() => {
    (async (): Promise<void> => {
      const response = await fetchPrismic<IData>(cmsId, cmsType, {
        graphQuery: ``,
      });

      if (response) {
        setData(response.data);
      }
    })();
  }, [cmsId, cmsType]);

  return data;
};
